import Vue from "vue";

/**
 * 权限控制
 modifiers: {
      search: '查询',
      add: '新增',
      edit: '编辑',
      detail: '查看',
      delete: '删除',
      import: '导入',
      export: '导出',
      reset: '重置',
      spare: '备用',
      special: '专用'
}
 spare, special：备用权限用来补充一些特殊权限
 **/

const existAction = (modifiers) => {
    const state = Vue.store.state
    const module = state.JMenu.menuActive
    const actions = state.rolesAction
    let exist = false
    for (const modifiersKey in modifiers) {
        if (actions.includes(`${module}-${modifiersKey}`)) { exist = true; break; }
    }
    return exist
}

Vue.directive('action', {
    inserted(el, binding) {
        const { modifiers } = binding
        if (!existAction(modifiers)) el.parentNode && el.parentNode.removeChild(el)
    }
})
